
import { Component, Emit, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { Response, ResponseTestResult } from "@/store/responses/types";

const Responses = namespace("responses");

@Component({})
export default class AlarmTriggerTest extends Vue {
	@Responses.Action private triggerTestResponse: (alarmId: number) => Promise<void>;
	@Responses.Action private refreshResponses: () => Promise<void>;
	@Responses.Mutation private setTriggerTestResponseResult: (result: ResponseTestResult) => void;
	@Responses.State private currentAlarm: Response;
	@Responses.State private triggerTestResponseResult: ResponseTestResult | null;

	@Emit("alarm-trigger-test-closed")
	private handleModalHidden(): void {
		this.setTriggerTestResponseResult(null);
	}

	private async handleTriggerAlarm() {
		await this.triggerTestResponse(this.currentAlarm.responseID);

		if (this.triggerTestResponseResult.added) {
			setTimeout(async () => {
				await this.refreshResponses();
			}, 10000);
		}
	}

	private get testFailReason(): string {
		if (!this.triggerTestResponseResult.groupArmed) {
			return "Alarm was not triggered - area is disarmed.";
		}

		if (!this.triggerTestResponseResult.responseArmed) {
			return "Alarm was not triggered - alarm is disarmed.";
		}

		return "Alarm was not triggered - area is disabled.";
	}

	private get autoHandleReason(): string {
		if (!this.triggerTestResponseResult.responseAutoHandled) {
			return "";
		}

		let reason;

		if (!this.triggerTestResponseResult.groupArmed) {
			reason = "the area is disarmed and the device is set to log disarmed alarms.";
		} else if (!this.triggerTestResponseResult.responseArmed) {
			reason = "the alarm is disarmed and the device is set to log disarmed alarms.";
		} else {
			reason = "it is configured to be auto-handled.";
		}

		reason = `Alarm was auto handled because ${reason}`;

		return reason;
	}
}
